<template>
	<div>
		<div class="list01">
			<dl>
				<dd v-for="(item, index) in list" :key="index" v-if="item.id != topID">
					<div class="list01-a" @click='toDetal(item)'>{{item.title}}</div>
					<span class="span_11">{{item.created_at.slice(0,10)}}</span>
				</dd>
			</dl> 
		</div>
		<div class="fenye" v-if="pageNum && list && list.length>0">
			<el-pagination
				background
				layout="prev, pager, next"
				:total="this.pageObj.total"
				:page-size="pageNum"
				prev-text="上一页"
				next-text="下一页"
				:pager-count='5'
				:hide-on-single-page='this.pageObj.total < pageNum+1'
				@current-change="pageChange($event)"
				>
			</el-pagination>
		</div>
	</div>
</template>

<script>
	
	
	
	
	export default {
	  name: 'list',
		props: ['listId','piece','page','topID'],
		data(){
			return{
				id:'',
				parentId:'',
				list:[],
				pieceNum:'',
				pageNum:'',
				pageObj:[],
				pagee:1,
				listtopID:'',
			}
		},
		methods:{
			//频道页列表
			res_newsList(){
				this.axios.get("/api/news/listNews?category_id="+this.id+'&limit='+this.pieceNum)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							this.list = response.data.reslut.data;
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			//列表页带分页列表
			res_newsList2(e,p){
				this.axios.get("/api/news/listNews?category_id="+this.id+'&limit='+e+'&page='+p)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							this.pageObj = response.data.reslut;
							this.list = this.pageObj.data;
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			
			//跳转详情页
			toDetal(item){
				console.log(item)
				if(item.outurl != '' && item.outurl != null){
					window.open(item.outurl,"_blank");
					// window.location.href = item.outurl
				}else{
					this.$router.push({
						path:'/slider/'+ item.parent_id +'/detail',
						query:{
							category_id:item.category_id,
							id:item.id
						}
					})
				}
				
			},
			pageChange(curPage){
				this.res_newsList2(this.pageNum,curPage)
			}
			
		},
		created() {
			
			setTimeout(()=>{
				this.id = this.listId;
				this.pieceNum = this.piece;
				this.pageNum = this.page;
				if(!this.pageNum){
					// console.log("频道页列表",this.pieceNum)
					this.res_newsList();
				}else{
					// console.log("列表页列表",this.pageNum)
					this.res_newsList2(this.pageNum,this.pagee);
				}
			},10)
			
		},
		watch :{
			'listId' (to, from) {
					// 对路由变化作出响应...
					// console.log('to',to);
					// console.log('from',from);
					this.id = this.listId;
					if(!this.pageNum){
						this.res_newsList();
					}else{
						this.res_newsList2(this.pageNum,this.pagee);
					}
			}
		},
	}
</script>

<style>
</style>